import React from 'react'
import { Link } from 'react-router-dom'
import { BaseUrl } from '../../../helper/BaseUrl'


export default function MediaDetailBanner({ data = {} }) {
  const breadcrumbTitle = data.title?.length > 15
    ? `${data.title.substring(0, 15)}...`
    : data.title;
  const titleParts = data.title?.split(":") || [];
  const titleLead = titleParts.shift();
  const titleRemainder = titleParts.join(":").trim();

  return (
    <>
      <section className='mediadetail-banner-area'>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-10 col-md-10 col-sm-10'>
              <div className='media-detail-breadcrumb'>
                <ul className='dynamic-breadcrumb'>
                  <li><Link to={"/"}>Home</Link></li>
                  <li><Link to={"/media"}>Media</Link></li>
                  <li>{breadcrumbTitle}</li>
                </ul>
              </div>

              <h1 className='heading'>
                {titleRemainder ? <>{titleLead}: <span>{titleRemainder}</span></> : data.title}
              </h1>
            </div>
            <div className='col-lg-12'>
              <div className='media-detail-banner-img'>
                <img src={data.banner_image ? BaseUrl + data.banner_image : ""} className='img-responsive' alt={data.title || 'media detail'} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
